(function() {
  'use strict';

  angular.module('ringbaPortal').directive('clickOutsideSidebar', clickOutsideSidebar);

  function clickOutsideSidebar(
    $document,
    $timeout,
    $transitions,
    mediaQueryService,
    sidebarService
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };
    return directive;

    function link($scope, element, attributes) {
      const elementId = attributes.elementId;
      let stateChangeSuccessHandler,
        deregisterBroadcastListener;

      _onInit();

      function _onInit() {
        if (mediaQueryService.evaluateMediaQuery('mdMax')) {
          _setSidebarMinifiedStatus(true);
          _setBroadcastListener();
        }

        $(window).resize(_handleWindowResize);
      }

      function _handleWindowResize() {
        if (mediaQueryService.evaluateMediaQuery('mdMax') && !deregisterBroadcastListener) {
          _setSidebarMinifiedStatus(true);
          _setBroadcastListener();
        } else if(!mediaQueryService.evaluateMediaQuery('mdMax') && deregisterBroadcastListener) {
          _setSidebarMinifiedStatus(false);
          deregisterBroadcastListener();
          detachHandler();
          deregisterBroadcastListener = undefined;
        }
      }

      function _setBroadcastListener() {
        deregisterBroadcastListener = $scope.$on('sidebarMinified', function () {
          // On mobile, when page-sidebar-opened-on-mobile class is added to the page
          // the sidebar opens up
          if (!sidebarService.sidebarMinified) {
            attachHandler();
          } else {
            detachHandler();
          }
        });
      }
      
      function attachHandler() {
        $timeout(function () {
          $document.on('click', eventHandler);

          stateChangeSuccessHandler = $transitions.onSuccess({}, function() {
            _setSidebarMinifiedStatus(true);
            detachHandler();
          });
        }, 0);
      }

      function detachHandler() {
        $document.off('click', eventHandler);
        if(stateChangeSuccessHandler) {
          stateChangeSuccessHandler();
          stateChangeSuccessHandler = undefined;
        }
      }

      function eventHandler(event) {
        const elementFound = $(event.target).closest('#' + elementId);
        if (!elementFound.length) {
          // Running expression inside $timeout, triggers the digest cycle
          _setSidebarMinifiedStatus(true);
          detachHandler();
        }
      }

      function _setSidebarMinifiedStatus(status) {
        $timeout(function () {
          sidebarService.sidebarMinified = status;
        });
      }

      $scope.$on('$destroy', function() {
        detachHandler();
        $(window).off('resize', _handleWindowResize);
      });

    }
  }

})();
